<template>
  <div class="wrapper">
    <notice-detail></notice-detail>
  </div>
</template>

<script>
import noticeDetail from "@/app/shop/components/noticeDetail.vue";
export default {
  name: "viewNoticeDetail",
  components: {
    noticeDetail
  }
};
</script>

<style scoped></style>
